export function getCalendarOffset(year, month) {
    const day = new Date(year, month, 1).getDay();
    return day * -1;
}
